<template>
  <div class="parent d-flex flex-column justify-center">
    <div class="mx-auto">
      <v-img :class="{ 'rounded rounded-circle': true }"
        :style="{ borderWidth: '2px', borderStyle: 'solid', borderRadius: '4px', borderColor: $vuetify.theme.currentTheme.primary }"
        :src="image" width="150px" aspect-ratio="1"></v-img>
    </div>
    <div class="mx-auto display-1 my-4 white--text">{{ user != null ? (user.user === undefined ? user.name :
      user.user.name) : "School Portal" }}</div>
    <div class="mx-auto my-2" style="max-width: 350px; width: 100%;">
      <v-alert v-if="error" type="error" variant="tonal" class="mb-4">
        {{ errorMessage }}
      </v-alert>

      <v-text-field @keyup.enter="unlock" autofocus :readonly="loading" color="primary" type="text"
        placeholder="Enter code" append-icon="mdi-key" dark v-model="mfa.code" outlined rounded dense
        class="text-white"></v-text-field>

      <!-- <div class="d-flex justify-end mt-2">
       <v-switch
         v-model="usingRecovery"
         :label="usingRecovery ? 'Using Recovery Code' : 'Use Recovery Code'"
         color="primary"
         hide-details
         class="mt-0"
       ></v-switch>
     </div> -->
    </div>
    <div class="text-center my-3">
      <v-btn :loading="loading" color="primary" outlined rounded @click.stop="unlock">
        <v-icon left>mdi-shield-check</v-icon>
        Verify & Unlock
      </v-btn>
      <message-box :show="messageShow" :message="message" :type="messageType"
        v-on:close-message="messageShow = !messageShow" style="z-index: 999999999"></message-box>
    </div>
  </div>
</template>

<script>
import Defaults from "@/shared/Defaults";
import MessageBox from "@ui/components/MessageBox";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import Apptypes from "@/shared/constants/apptypes";

export default {
  name: "LockScreen",
  components: { MessageBox },
  props: ['user', 'locked'],
  data: () => ({
    mfa: {
      userId: '',
      code: '',
    },
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    errorCount: 0,
    error: false,
    errorMessage: 'Invalid code. Please try again.',
    nsuk: false
  }),

  computed: {
    image: function () {
      if (this.user == null) {
        return 'https://picsum.photos/seed/picsum/200/300'
      } else {
        return Defaults.api + '/profile-picture/fetch?user=' + (this.user.user === undefined ? this.user.userId : this.user.user.userId);
      }
    }
  },

  methods: {
    unlock() {
      this.loading = true;
      this.error = false;


      // Prepare the MFA data
      const mfaData = {
        userId: this.user.user === undefined ? this.user.userId : this.user.user.userId,
        code: this.mfa.code,
        // recovery: this.mfa.recovery
      };

      // Verify MFA code
      Api.auth.verifyMfa(mfaData)
        .then(res => {
          if (res.data) {
            this.errorCount = 0;
            this.locked = false;
            this.error = false;

            return Api.auth.updateLock({ locked: false })
              .then(() => {
                this.$emit("reset");
              })

          } else {
            this.handleVerificationError();
          }
        })
        .catch(err => {
          this.locked = true;
          this.handleVerificationError();
          ErrorResolver.checkErrors(this, err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleVerificationError() {
      this.error = true;
      this.errorCount++;
      this.errorMessage = 'Invalid verification code. Please try again.';

      if (this.errorCount >= 3) {
        this.errorMessage = 'Too many failed attempts. Logging out...';
        setTimeout(() => {
          this.$emit("logout");
        }, 1500);
      }
    }
  },

  watch: {
    user: function (newVal) {
      if (newVal != null) {
        this.mfa.userId = newVal.user === undefined ? newVal.userId : newVal.user.userId;
      }
    }
  },

  created() {
    this.nsuk = Apptypes.NSUK === Apptypes.CURRENT
  }
}
</script>

<style scoped>
.parent {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background-color: #000000ea;
  z-index: 99999999;
}

.v-text-field--outlined>>>fieldset {
  border-color: var(--v-primary-base);
}

.text-white .v-text-field__slot input {
  color: white !important;
}

.image-nsuk {
  border: solid #016b4b 4px
}

.image-lafia {
  border: solid #FF9931 4px
}
</style>
